export default __webpack_public_path__ + "static/media/Animals11.64661799.jpg";